import { render } from "./Index.vue?vue&type=template&id=2447758b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=2447758b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2447758b"

export default script